export const education = [
    {
        degree: 'B.Tech – Computer Science & Engineering',
        school: 'Techno International Batanagar (MAKAUT)',
        duration: '2022 – 2026',
        location: 'West Bengal, India',
        score: 'CGPA: 8.1',
        scoreLabel: 'Final CGPA',
        highlights: [
            'Core subjects: Data Structures & Algorithms, DBMS, OS, OOPs, Computer Networks',
            'Completed B.Tech in 2026 with a provisional certificate issued by the institution',
            'Active participant in national and inter-college hackathons, winning multiple awards',
            'Built and deployed real-world projects — AI surveillance systems, web platforms, and automation tools',
        ],
    },
    {
        degree: '12th Grade (CISCE Board)',
        school: 'St. Mary\'s High School',
        duration: '2019 – 2021',
        location: 'Kolkata, India',
        score: '87.6%',
        scoreLabel: 'Percentage',
        highlights: [
            'Stream: Science (Physics, Chemistry, Mathematics, Computer Science)',
            'Secured strong academic standing with consistent performance',
        ],
    },
];

export const AboutMe = [
    {
        title: 'Certificates',
        items: [
            { label: 'Data Science – Odin School', note: '6 Months · Online', link: '/documents/data_sci_cert.pdf' },
            { label: 'Web Developer – IBM Skills Build', note: 'Online', link: '' },
            { label: 'MERN Stack – Acesoftech Academy', note: '6 Months · Offline', link: '/documents/mern_cert.pdf' },
            { label: 'Core Java – Acesoftech Academy', note: '3 Months · Offline', link: '' },
            { label: 'DevOps – EMCTDA', note: 'Offline via college training', link: '/documents/devops_cert.pdf' },
        ]
    },
    {
        title: 'Hobbies & Interests',
        items: [
            'Gymming & exercising',
            'Learning new technologies',
            'Creating innovative projects',
            'Exploring AI/ML & automation',
        ]
    },
    {
        title: 'Achievements',
        items: [
            'Won multiple national & inter-college hackathons for innovative software & AI projects',
            'Delivered 25+ freelance applications — backend, APIs, automation, and modern web stacks',
            'Independently built & deployed secure AI/ML solutions including real-time surveillance & encrypted storage',
            'Known as a quick learner, effective communicator, and adaptable team player',
        ]
    },
    {
        title: 'Strengths & Weakness',
        items: [
            'Strong MERN development skills',
            'Fast learner, adaptable, and curious',
            'Creative thinker and team player',
            'Sometimes overcommit due to eagerness to grow',
            'Can hyper-focus on polishing beyond scope',
        ]
    }
];

export const verifiedCredentials = [
    {
        title: 'B.Tech Provisional Certificate',
        type: 'Education',
        issuer: 'Techno International Batanagar (MAKAUT)',
        period: 'Issued in 2026',
        description: 'Provisional certificate confirming completion of B.Tech in Computer Science & Engineering.',
        link: '/documents/btech-provisional-certificate.pdf'
    },
    {
        title: 'Experience Letter — Outbro',
        type: 'Experience',
        issuer: 'Outbro',
        period: 'Nov 2023 – Jun 2025',
        description: 'Official experience letter for Website Manager & Full-Stack Developer responsibilities.',
        link: '/documents/outbro-experience-letter.pdf'
    },
    {
        title: 'Experience Letter — TechStax',
        type: 'Experience',
        issuer: 'TechStax',
        period: 'Jul 2025 – Jan 2026',
        description: 'Official experience letter for Full-Stack / Software Engineer role.',
        link: '/documents/techstax-experience-letter.pdf'
    },
];
